import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function FloatingWhatsApp() {
  return <motion.a href="https://wa.me/15551234567" // Replace with real number
  target="_blank" rel="noopener noreferrer" className="fixed bottom-[30px] right-[30px] z-50 w-[60px] h-[60px] md:w-[70px] md:h-[70px] bg-[#25D366] rounded-full flex items-center justify-center shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:bg-[#20bd5a] transition-colors group" animate={{
    y: [0, -10, 0]
  }} transition={{
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-101">
      <MessageCircle className="text-white w-7 h-7 md:w-8 md:h-8" data-id="element-102" />

      {/* Tooltip */}
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-deep-blue text-white font-montserrat text-xs py-2 px-4 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-md hidden md:block" data-id="element-103">
        Escríbele a Lorena directamente 💙
        {/* Arrow pointer */}
        <div className="absolute right-[-4px] top-1/2 -translate-y-1/2 w-2 h-2 bg-deep-blue rotate-45" data-id="element-104"></div>
      </div>
    </motion.a>;
}